export default __webpack_public_path__ + "static/assets/8d3a40f6a92a202defbbc83de09ff42a.png";